export { BelowTheFold as default } from './BelowTheFold'
